export enum NewsletterType {
    GENERAL = 1,
    PRODUCTS = 2,
    ARTICLES = 3,
}
